import { ArrayParam, StringParam, useQueryParams } from 'use-query-params'

import { ValidationSubmissionStatus } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { useDidMountEffect, useQueryList } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { ValidationSubmissionsTable } from './validationSubmissionsTable/ValidationSubmissionsTable'

export function ValidationSubmissionsContainer() {
  const { validationSubmissionsService } = useServices()

  const [queryParams, setQueryParams] = useQueryParams({
    query: StringParam,
    statuses: ArrayParam,
    partnerId: StringParam,
    countryCodes: ArrayParam,
    configurationIds: ArrayParam,
    sort: StringParam,
    direction: StringParam,
    organisationId: StringParam
  })

  const [{ totalResults, isLoading, dataOrNull, errorMessageOrNull }, { nextPage, previousPage, query, refresh }] =
    useQueryList(validationSubmissionsService.getValidationSubmissionsList, {
      ...queryParams,
      statuses: (queryParams.statuses as ValidationSubmissionStatus[]) ?? []
    })

  useDidMountEffect(() => {
    query(queryParams)
  }, [queryParams])

  return (
    <ValidationSubmissionsTable
      data={dataOrNull}
      isLoading={isLoading}
      errorMessage={errorMessageOrNull}
      nextPage={nextPage}
      previousPage={previousPage}
      totalResults={totalResults}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      refresh={refresh}
    />
  )
}
